import Vue from "vue";

export const store = Vue.observable({
    me: {},
    navbarTitle: "",
    navbarSubtitle: "",
    appName: "DBD Portal",
});

export const mutations = {
    setMe(me) {
        store.me = me;
    },
    setNavbarTitle(title, subtitle = "", setDocumentTitle = true) {
        store.navbarTitle = title;
        store.navbarSubtitle = subtitle;
        if (setDocumentTitle) {
            document.title =
                title +
                (subtitle ? ` • ${subtitle}` : "") +
                " • " +
                store.appName;
        }
    },
    setNavbarSubtitle(subtitle) {
        store.navbarSubtitle = subtitle;
        document.title =
            store.navbarTitle +
            (subtitle ? ` • ${subtitle}` : "") +
            " • " +
            store.appName;
    },
};

export const getters = {
    isDesigner: () => store.me.role === "ClientBasic",
    isCustomer: () => store.me.role === "ClientAdmin",
    isDeveloper: () => store.me.role === "Developer",
    hasClientRole: () => store.me.role?.includes("Client") ?? false,
    hasCompanyRole: () =>
        store.me.role?.includes("Company") || store.me.role === "Developer",
};
